import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { DropRequestsResponse } from "@/actions/ssr/scheduling/getDropRequestsSSR";
import type { SchedulingAssignmentsResponse } from "@/actions/ssr/scheduling/getSchedulingAssignmentsSSR";
import type { SwapRequestsResponse } from "@/actions/ssr/scheduling/getSwapRequestsSSR";

interface PortalDropSwapState {
  dropRequests: DropRequestsResponse;
  openAssignments: SchedulingAssignmentsResponse;
  swapRequests: SwapRequestsResponse;
  incomingSwapRequests: SwapRequestsResponse;
}

const EMPTY_DROP: DropRequestsResponse = {
  next: null,
  previous: null,
  count: 0,
  total_pages: 1,
  current_page: 1,
  results: [],
  kpi: {
    total_count: 0,
    pending_count: 0,
    approved_count: 0,
    rejected_count: 0,
  },
};

const EMPTY_ASSIGNMENTS: SchedulingAssignmentsResponse = {
  next: null,
  previous: null,
  count: 0,
  total_pages: 1,
  current_page: 1,
  results: [],
};

const EMPTY_SWAP: SwapRequestsResponse = {
  next: null,
  previous: null,
  count: 0,
  total_pages: 1,
  current_page: 1,
  results: [],
  kpi: {
    total_count: 0,
    pending_count: 0,
    approved_count: 0,
    rejected_count: 0,
  },
};

const initialState: PortalDropSwapState = {
  dropRequests: EMPTY_DROP,
  openAssignments: EMPTY_ASSIGNMENTS,
  swapRequests: EMPTY_SWAP,
  incomingSwapRequests: EMPTY_SWAP,
};

const portalDropSwapSlice = createSlice({
  name: "portalDropSwap",
  initialState,
  reducers: {
    setPortalDropSwapDropRequests(
      state,
      action: PayloadAction<DropRequestsResponse>,
    ) {
      state.dropRequests = action.payload;
    },
    setPortalDropSwapOpenAssignments(
      state,
      action: PayloadAction<SchedulingAssignmentsResponse>,
    ) {
      state.openAssignments = action.payload;
    },
    setPortalDropSwapSwapRequests(
      state,
      action: PayloadAction<SwapRequestsResponse>,
    ) {
      state.swapRequests = action.payload;
    },
    setPortalDropSwapIncomingSwapRequests(
      state,
      action: PayloadAction<SwapRequestsResponse>,
    ) {
      state.incomingSwapRequests = action.payload;
    },
  },
});

export const {
  setPortalDropSwapDropRequests,
  setPortalDropSwapOpenAssignments,
  setPortalDropSwapSwapRequests,
  setPortalDropSwapIncomingSwapRequests,
} = portalDropSwapSlice.actions;
export default portalDropSwapSlice.reducer;
